import React from 'react';
import Problem from 'src/views/common/Problem/Solving/Problem';

export default function ProblemInHomework({problem})
{
    return(
            <Problem problem={problem} />
    );
}